module.exports = __webpack_public_path__ + "static/img/Aions_Mar_7.9dae9c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Aions_Mar/Aions_Mar_7.png
// module id = GHcf
// module chunks = 19